import React, { useEffect, useRef, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Checkbox } from "../ui/checkbox";
import { Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { maskCPF, validaCPF } from "../../lib/validators";
import { AssinaturaCanvas } from "./AssinaturaCanvas";
import { DECLARACAO, PAPEL_LABEL, fmtCPF } from "./assinaturasConst";

export const AssinarModal = ({ participante, onClose, onConfirm }) => {
  const [nome, setNome] = useState("");
  const [cpf, setCpf] = useState("");
  const [aceite, setAceite] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!participante) return;
    setNome(participante.nome || "");
    setCpf(fmtCPF(participante.cpf));
    setAceite(false);
  }, [participante]);

  const confirmar = async () => {
    if (nome.trim().length < 3) return toast.error("Informe o nome completo");
    if (!validaCPF(cpf)) return toast.error("CPF inválido");
    if (canvasRef.current?.isEmpty()) return toast.error("Desenhe a assinatura no quadro");
    if (!aceite) return toast.error("Confirme a declaração antes de assinar");
    setSalvando(true);
    try {
      await onConfirm({ nome: nome.trim(), cpf, assinatura_base64: canvasRef.current.toDataURL(), confirmacao: true });
      onClose();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Não foi possível registrar a assinatura");
    } finally {
      setSalvando(false);
    }
  };

  const papel = participante?.papel;
  return (
    <Dialog open={!!participante} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg" data-testid="assinar-modal">
        <DialogHeader>
          <DialogTitle>Assinatura presencial · {PAPEL_LABEL[papel]}</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label>Nome completo</Label>
            <Input value={nome} onChange={(e) => setNome(e.target.value)} data-testid="assinar-modal-nome" />
          </div>
          <div>
            <Label>CPF</Label>
            <Input value={cpf} onChange={(e) => setCpf(maskCPF(e.target.value))} placeholder="000.000.000-00" data-testid="assinar-modal-cpf" />
          </div>
          <div>
            <Label>Assinatura</Label>
            {participante && <AssinaturaCanvas ref={canvasRef} testId="assinar-modal-canvas" />}
          </div>
          <label className="flex items-start gap-2 text-sm cursor-pointer">
            <Checkbox checked={aceite} onCheckedChange={(v) => setAceite(!!v)} data-testid="assinar-modal-aceite" className="mt-0.5" />
            <span>{DECLARACAO[papel]}</span>
          </label>
          <div className="flex justify-end gap-2 pt-2">
            <Button variant="outline" onClick={onClose} disabled={salvando} data-testid="assinar-modal-cancelar">Cancelar</Button>
            <Button onClick={confirmar} disabled={salvando} className="text-white" style={{ background: "#1B3A6B" }} data-testid="assinar-modal-confirmar">
              {salvando ? <Loader2 size={14} className="mr-1 animate-spin" /> : <ShieldCheck size={14} className="mr-1" />}
              Confirmar assinatura
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
